import {Injectable} from "@angular/core";
import {ApiService} from "../../../../shared/services/api/api.service";
import {Observable} from "rxjs";
import {IPagination} from "../../../../shared/services/api/interface/pagination.interface";
import {IGetVehicleList, IVehicleCreate, IVehicleUpdate} from "../interface/vehicle.interface";


@Injectable({
  providedIn: 'root'
})
export class VehicleService{
  constructor(private readonly apiService: ApiService) {
  }

  getVehicleList(){
    return this.apiService.get<IGetVehicleList[]>('vehicle');
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`vehicle/vehicle-filter-list`, {event: event, filter: filter})
  }

  getById(id: string){
    return this.apiService.get(`vehicle/${id}`);
  }

  createVehicle(vehicle: IVehicleCreate){
    return this.apiService.post('vehicle/create', vehicle);
  }

  updateVehicle(vehicle: IVehicleUpdate){
    return this.apiService.patch('vehicle/update', vehicle);
  }

  deleteVehicle(id: number){
    return this.apiService.delete(`vehicle/delete/${id}`);
  }
}
